import React from 'react'
import QRCode from 'qrcode.react'
import styles from './wechat-payment.module.scss'

const WechatNativePayment = ({ codeUrl, totalPrice, hideQrCode }) => {
  return <div className={styles.wrapper}>
    <div className={styles.section}>
      <p>微信扫码，支付 {totalPrice} 元</p>
      <QRCode
        value={codeUrl}
        size={150}
        style={{ border: '1px solid rgba(0,0,0,0.1)' }}
        includeMargin={true} />
      <button
        className='btn-red'
        style={{ display: 'block', margin: '0 auto' }}
        onClick={hideQrCode}>
        取消支付
      </button>
    </div>
  </div>
}

export default WechatNativePayment
